import { createFileRoute } from '@tanstack/react-router'

import ProjectWIVReport from 'pages/ProjectWIVReport'

export const Route = createFileRoute('/_auth/projects/$id/wiv-report')({
  component: ProjectWIVReport,
})
